module.exports = __webpack_public_path__ + "static/media/entity-viewer-header.bf48c285.png";